module.exports = __webpack_public_path__ + "img/avg-candidates.383519da.png";